import { db } from '../config/firebaseconfig'

const uuid = require('uuid/v1')

/*

Fetches userAssignments and creates any that aren't in the store.
These are the user instances of their assignments and tracks each
user's unique progress through an assignment.

*/

export default function getUserAssignments(
  assignments,
  activeUserId,
  activeUser,
  {
    fetchingUserAssignments,
    fetchingUserAssignmentsSuccess,
    fetchingUserAssignmentsError,
  }) {
  fetchingUserAssignments()
  db.collection('userAssignments').doc(activeUserId).get()
    .then( (doc) => {
      let userAssignments = {}
      const storedUserAssignments = doc.data()
      const assignmentIds = Object.keys(assignments)
      const assignedToUser = Object.keys(activeUser.assignments)
      assignedToUser.forEach( (assignedKey) => {
        if (activeUser.assignments[assignedKey] && storedUserAssignments[assignedKey]) {
          //  copy userAssignment from store
          userAssignments[assignedKey] = storedUserAssignments[assignedKey]
        } else if (activeUser.assignments[assignedKey]) {
          // create new userAssignment in store and display
          userAssignments[assignedKey] = {
            userId: activeUserId,
            assignmentId: assignedKey,
            userAssignmentId: uuid(),
            activity: null,
            grade: null,
          }
          db.collection('userAssignments').doc(activeUserId).set({
            [assignedKey]: userAssignments[assignedKey],
          })
        }
      })
      fetchingUserAssignmentsSuccess(userAssignments)
    })
    .catch( (err) => {
      if (err.code === 'not-found') {
        db.collection('userAssignments').doc(activeUserId).set({})
          .then( () => {
            getUserAssignments(
              assignments, 
              activeUserId,
              activeUser,
              {
                fetchingUserAssignments,
                fetchingUserAssignmentsSuccess,
                fetchingUserAssignmentsError,
              })
          })
          .catch( (err) => console.log(err) )
      } else {
        fetchingUserAssignmentsError(err)    
      }
    })
}

// If there are no empty objects, this currently turns state.assignmentsView.activeUserAssignments
// to {} instead of null. Keep this in mind!


// WEBPACK FOOTER //
// ./src/helpers/getUserAssignments.js